import { CLEAR_ERROR, SET_ERROR } from "../Actions/types";
const initial = { open: false, message: null, type: null };

export default function errorReducer(state = initial, action) {
  switch (action.type) {
    case SET_ERROR:
      return {
        open: true,
        message: action.payload?.message ?? String(action.payload ?? ""),
        type: action.payload?.type ?? "error",
      };
    case CLEAR_ERROR:
      return initial;
    default:
      return state;
  }
}
